import api from './api';

const ENDPOINT = 'sales';

const SaleService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
  search: (params) => api.get(`${ENDPOINT}/search`, { params }),
  getSummary: () => api.get(`${ENDPOINT}/summary`),
  export: (filters) => api.post(`${ENDPOINT}/export`, { filters }),
  import: (networkId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('networkId', networkId);

    return api.post(`${ENDPOINT}/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
    });
  },
};

export default SaleService;
